<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { api, messageFrom } from '../api'
import type { PublicSpeaker } from '../types'

const emit = defineEmits<{ navigate: [path: string] }>()
const speakers = ref<PublicSpeaker[]>([])
const loading = ref(true)
const error = ref('')

function hours(value: number): string {
  return value.toLocaleString('ru-RU', { maximumFractionDigits: 1 })
}

async function load(): Promise<void> {
  loading.value = true
  error.value = ''
  try {
    speakers.value = (await api<{ speakers: PublicSpeaker[] }>('/api/public/speakers')).speakers
  } catch (reason) {
    error.value = messageFrom(reason)
  } finally {
    loading.value = false
  }
}

onMounted(load)
</script>

<template>
  <main class="public-page public-page--home">
    <header class="public-intro">
      <p class="public-kicker">Архив выступлений</p>
      <h1>Задай вопрос спикеру</h1>
      <p>
        Здесь собраны ответы по записям выступлений. Выбери человека, чей опыт хочешь услышать.
      </p>
    </header>

    <p v-if="loading" class="public-state">Загружаем спикеров…</p>
    <div v-else-if="error" class="public-state public-state--error" role="alert">
      <p>{{ error }}</p>
      <button class="public-link-button" type="button" @click="load">Попробовать снова</button>
    </div>
    <p v-else-if="!speakers.length" class="public-state">
      Здесь пока нет готовых разговоров. Они появятся после обработки записей.
    </p>
    <section v-else class="public-speaker-list" aria-label="Спикеры">
      <button
        v-for="speaker in speakers"
        :key="speaker.slug"
        class="public-speaker-card"
        type="button"
        @click="emit('navigate', `/speakers/${speaker.slug}`)"
      >
        <span class="public-speaker-card__hours">{{ hours(speaker.recordingHours) }} ч записей</span>
        <strong>{{ speaker.name }}</strong>
        <span class="public-speaker-card__summary">{{ speaker.summary }}</span>
        <span class="public-speaker-card__action">Перейти к разговору</span>
      </button>
    </section>
  </main>
</template>
